'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _svg = require('../../utils/svg.utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var controls = (0, _svg.getSvgControls)();
var Svg = controls.Svg,
    Path = controls.Path;

var Unknow = function (_React$Component) {
    _inherits(Unknow, _React$Component);

    function Unknow() {
        _classCallCheck(this, Unknow);

        return _possibleConstructorReturn(this, (Unknow.__proto__ || Object.getPrototypeOf(Unknow)).apply(this, arguments));
    }

    _createClass(Unknow, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                Svg,
                { width: '26', height: '32', viewBox: '0 0 26 32' },
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M12.797 21.18c-0.336 0-0.609 0.273-0.609 0.609v1.219c0 0.336 0.273 0.609 0.609 0.609s0.609-0.273 0.609-0.609v-1.219c0-0.336-0.273-0.609-0.609-0.609z' }),
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M10.005 11.389c0.052-0.056 0.107-0.117 0.165-0.182 0.521-0.581 1.234-1.377 2.787-1.377 1.724 0 2.792 1.127 2.792 2.171 0 1.046-0.509 1.514-1.661 2.473l-0.081 0.068c-1.282 1.069-1.819 1.889-1.819 4.2 0 0.336 0.273 0.609 0.609 0.609s0.609-0.273 0.609-0.609c0-1.941 0.358-2.412 1.38-3.264l0.081-0.067c1.127-0.938 2.1-1.748 2.1-3.409 0-1.63-1.533-3.39-4.010-3.39-2.097 0-3.136 1.159-3.694 1.781-0.053 0.059-0.102 0.114-0.149 0.164-0.23 0.246-0.216 0.632 0.030 0.861s0.632 0.216 0.861-0.030z' }),
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M12.797 28.797c6.937 0 12.797-5.86 12.797-12.797s-5.86-12.797-12.797-12.797-12.797 5.86-12.797 12.797 5.86 12.797 12.797 12.797zM12.797 4.422c6.276 0 11.578 5.302 11.578 11.578s-5.302 11.578-11.578 11.578-11.578-5.302-11.578-11.578 5.302-11.578 11.578-11.578z' })
            );
        }
    }]);

    return Unknow;
}(_react2.default.Component);

Unknow.propTypes = {
    fill: _react2.default.PropTypes.string
};

exports.default = Unknow;


//////////////////
// WEBPACK FOOTER
// ./~/pluton-assets/lib/icons/svg/unknow.js
// module id = 1129
// module chunks = 0